import React from 'react';

export const Alarm = ({hidden}) => (
  <audio id="alertPlayer" controls autoPlay hidden={hidden} loop>
    <source src="http://hydrology.gov.np/siren.ogg" type="audio/ogg"/>
    <source src="http://hydrology.gov.np/siren.mp3" type="audio/mpeg"/>
    {/*<source src="./siren.ogg" type="audio/ogg" />*/}
    {/*<source src="./siren.mp3" type="audio/mpeg" />*/}
    Your browser does not support the audio element.
  </audio>
);





// WEBPACK FOOTER //
// ./src/components/Watch/Alarm.js